import { useLocation } from 'react-router-dom';

import UserConnexionProcess from '../features/auth/components/userConnexionProcess/UserConnexionProcess';
import useAuth from '../features/auth/useAuth';
import ModalContainer from '../features/modals/components/ModalContainer';
import AdBlankPage from '../pages/AdBlankPage';
import { APIStatus } from '../services/axiosEnums';
import LayoutMainContent from './LayoutMainContent';
import MainContainer from './MainContainer';
import './styles/main.scss';

interface ILayoutProps {
  children: React.ReactNode;
}
const Layout = ({ children }: ILayoutProps) => {
  const { maintenancePageOnly, isLogged, userApiStatus, user } = useAuth({});

  const { pathname } = useLocation();
  const path = maintenancePageOnly ? '/maintenance' : pathname;

  if (
    !user &&
    (userApiStatus === APIStatus.PENDING || userApiStatus === APIStatus.REJECTED)
  ) {
    return <UserConnexionProcess />;
  }

  if (!isLogged || maintenancePageOnly) {
    return <MainContainer>{children}</MainContainer>;
  }

  return (
    <MainContainer>
      <ModalContainer />
      {
        // External page for display ad
        path.split('/')[1] === 'ad' ? (
          <AdBlankPage />
        ) : (
          // main app logged content
          <LayoutMainContent isLogged={isLogged} path={path}>
            {children}
          </LayoutMainContent>
        )
      }
    </MainContainer>
  );
};

export default Layout;
